<div class="h-[calc(100%-40px)] scrollbar">
  <div class="bg-neutral-5 p-2">
    <kendo-textbox
      [placeholder]="searchPlaceholder"
      [clearButton]="true"
      [value]="searchInput"
      (valueChange)="onSearchInput($event)"
      class="small-placeholder"
    >
      <ng-template kendoTextBoxPrefixTemplate>
        <span
          class="fa-icons icon-14 icon-magnifying-glass text-neutral-60 ml-2"
        ></span>
      </ng-template>
    </kendo-textbox>
  </div>

  <div class="p-2 flex flex-col gap-2">
    @if (isLoading.skeleton) {
      <maximizer-outlook-skeleton-card></maximizer-outlook-skeleton-card>
      <maximizer-outlook-skeleton-card></maximizer-outlook-skeleton-card>
    } @else {
      @if (isLoading.spinner) {
        <maximizer-loader type="legacy"></maximizer-loader>
      }
      @if (
        !this.isLoading.skeleton &&
        (searchPhrase?.length ?? 0) >= MIN_SEARCH_LENGTH &&
        (opportunities.length > 0 || cases.length > 0)
      ) {
        <div class="text-neutral-90 text-body py-2">
          <p>{{ getResultsCountString() }}</p>
        </div>
      }

      @if (
        (!searchPhrase && currentAbEntryIds.length === 0) ||
        (opportunities.length === 0 && cases.length === 0)
      ) {
        <div class="text-neutral-90 text-body py-2">
          <p>
            {{
              'outlook.main.related.noEntries'
                | translate
                  : { label: 'outlook.entries.entries' | translate | lowercase }
            }}
          </p>
          <p>
            {{
              'outlook.main.related.useSearchEmpty'
                | translate
                  : {
                      oppLabel: 'outlook.entries.opportunities' | translate,
                      caseLabel: 'cases' | translateVertical,
                    }
            }}
          </p>
        </div>
      } @else {
        <!-- Opportunities -->
        @if (userRights?.opportunities?.read) {
          <div class="pt-2 flex flex-col gap-2">
            <p class="subtitle-2">
              {{ 'outlook.entries.opportunities' | translate }}
              @if (opportunities.length > 0) {
                <span class="text-neutral-90 text-body">
                  {{
                    'outlook.main.related.count'
                      | translate
                        : {
                            count: 1,
                            total: opportunities.length,
                          }
                  }}
                </span>
              }
            </p>

            @if (opportunities.length === 0) {
              <div class="text-neutral-90 text-body">
                <p>
                  {{
                    'outlook.main.related.noEntries'
                      | translate
                        : {
                            label: 'outlook.entries.opportunities' | translate,
                          }
                  }}
                </p>
                <p>
                  {{
                    'outlook.main.related.useSearch'
                      | translate
                        : {
                            label: 'outlook.entries.opportunities' | translate,
                          }
                  }}
                </p>
              </div>
            } @else {
              <maximizer-outlook-opportunity-card
                [opportunity]="opportunities[0]"
                [userRights]="userRights"
                [mode]="cardMode"
                (save)="saveEmail($event, EntryType.Opportunity)"
              ></maximizer-outlook-opportunity-card>
            }

            @if (opportunities.length > 1) {
              <div class="text-center">
                <button
                  kendoButton
                  themeColor="primary"
                  fillMode="flat"
                  (click)="showAll(EntryType.Opportunity)"
                >
                  {{
                    'outlook.main.related.showAll'
                      | translate
                        : {
                            count: opportunities.length,
                            label: 'outlook.entries.opportunities' | translate,
                          }
                  }}
                </button>
              </div>
            }
          </div>
        }
        <!-- Cases -->
        @if (userRights?.customerService?.read) {
          <div class="pt-2 flex flex-col gap-2">
            <p class="subtitle-2">
              {{ 'cases' | translateVertical }}
              @if (cases.length > 0) {
                <span class="text-neutral-90 text-body">
                  {{
                    'outlook.main.related.count'
                      | translate
                        : {
                            count: 1,
                            total: cases.length,
                          }
                  }}
                </span>
              }
            </p>

            @if (cases.length === 0) {
              <div class="text-neutral-90 text-body">
                <p>
                  {{
                    'outlook.main.related.noEntries'
                      | translate
                        : {
                            label: 'cases' | translateVertical,
                          }
                  }}
                </p>
                <p>
                  {{
                    'outlook.main.related.useSearch'
                      | translate
                        : {
                            label: 'cases' | translateVertical,
                          }
                  }}
                </p>
              </div>
            } @else {
              <maximizer-outlook-case-card
                [case]="cases[0]"
                [userRights]="userRights"
                [mode]="cardMode"
                (save)="saveEmail($event, EntryType.Case)"
              ></maximizer-outlook-case-card>
            }

            @if (cases.length > 1) {
              <div class="text-center">
                <button
                  kendoButton
                  themeColor="primary"
                  fillMode="flat"
                  (click)="showAll(EntryType.Case)"
                >
                  {{
                    'outlook.main.related.showAll'
                      | translate
                        : {
                            count: cases.length,
                            label: 'cases' | translateVertical,
                          }
                  }}
                </button>
              </div>
            }
          </div>
        }
      }
    }
  </div>
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
></maximizer-outlook-notification>

@if (saveEmailDetail) {
  <maximizer-email-detail
    [emailProperties]="saveEmailDetailProperties"
    [entityTypeOverride]="trackingEntryType"
    (saveEmailKey)="onSaveEmailDetail($event.id, $event.type)"
    (closed)="saveEmailDetail = false"
  ></maximizer-email-detail>
}
